import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/interactive-menu/components/InteractiveMenuContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
